import React from "react";
import { useParams } from "react-router-dom";
import "./others.css";

import Template from "./Template/Template";
import TemplateDetail from "./Template/TemplateDetail";

export default function Others() {
  const { id } = useParams();

  return (
    <>
      <div className="others-header">
        <h2 className="others-title">기타</h2>
      </div>

      {id ? <TemplateDetail /> : <Template />}
    </>
  );
}